import type { ISupportThread } from '../../../models/Support/ISupportThread';
import { ThreadType } from '../../../models/Support/SupportEnums';

const BeaconAuthorName = 'Beacon';

// The Beacon bridge writes its note under a fixed author with no rep id or email; every rep-written note gets
// both from the session, so a rep who names themselves Beacon never matches.
const isBeaconContextNote = (thread: ISupportThread) =>
	thread.authorName === BeaconAuthorName && !thread.authorId && !thread.authorEmail;

/**
 * The one-line label for a collapsible context note, or undefined when the thread is an ordinary message.
 * The note's sender details are self-asserted, so the label carries that caution while the body is hidden.
 */
export const getContextNoteLabel = (thread: ISupportThread): string | undefined => {
	if (thread.type !== ThreadType.Note || !isBeaconContextNote(thread)) return undefined;
	return `Context from ${BeaconAuthorName} · sender unverified`;
};
